<span class="moneda_and_monto container-input-mount {{ classStyle }}">
	<strong class="simbolo_moneda">{{ symbolCoin ? symbolCoin : 'S/' }} </strong>
	<input
		[disabled]="disabled"
		type="text"
		class="form_element txt_monto {{ inputClass }}"
		placeholder="00.00"
		numeric
		[decimal]="true"
		[pattern]="limitsFormat ? '^(?!$)\\d{0,5}(?:\\.\\d{1,2})?$' : '^(?!$)\\d{0,10}(?:\\.\\d{1,2})?$'"
		[value]="valueText | number: '1.' + minDecimals + '-' + maxDecimals"
		(change)="changeEvent($any($event).target.value)"
		[ngClass]="{ 'border-error': submit && errorText }"
	/>
	<app-valid-message-form
		*ngIf="required && submit && errorText"
		[message]="errorText"
		type="error"
	></app-valid-message-form>
</span>
